import React from 'react';
import { storeData } from '../../data/storeData';
import StoreTemplate from '../../components/StoreTemplate';
import eptrueInside from '../../assets/images/epinside.jpg';

function EPTrue() {
    return <StoreTemplate storeData={storeData.epTrue} storeImage={eptrueInside} />;
}

export default EPTrue; 